// components/ChartExportMenu.js
import { Button, Dropdown, Menu } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { downloadChartAsPDF, downloadChartAsPNG, downloadChartAsSVG, downloadCSV } from "../../utils/utils";


const ChartExportMenu = ({ chartId, pdfName, csvData = null }) => {
  const menuItems = [
    {
      key: "pdf",
      label: "Download PDF",
      onClick: () => downloadChartAsPDF(chartId, `${pdfName}.pdf`),
    },
    {
      key: "png",
      label: "Download PNG",
      onClick: () => downloadChartAsPNG(chartId),
    },
    {
      key: "svg",
      label: "Download SVG",
      onClick: () => downloadChartAsSVG(chartId),
    },
  ];

  if (csvData) {
    menuItems.push({
      key: "csv",
      label: "Download CSV",
      onClick: () => downloadCSV(csvData),
    });
  }

  return (
    <Dropdown overlay={<Menu items={menuItems} />} placement="bottomRight" trigger={['click']}>
      <Button shape="circle" icon={<EllipsisOutlined />} className="shadow hover:shadow-md border border-transparent dark:border-white" />
    </Dropdown>
  );
};

export default ChartExportMenu;
